jQuery(document).ready(function ($) {

    $('.blog_load_more').click(function (e) {
        e.preventDefault()

        const post_type = $('.news-nav-active')[0].dataset.post_type;

        const button = $(this),
            data = {
                'action': 'blog_load_more',
                'post_type': post_type,
                'query': blog_load_more_params.posts,
                'page': blog_load_more_params.current_page
            }

        $.ajax({
            url: blog_load_more_params.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function (xhr) {
                button.text('Loading...')
            },
            success: function (data) {
                if (data) {
                    $('.article-container .post-card:last').after(data)
                    blog_load_more_params.current_page++

                    if (blog_load_more_params.current_page == blog_load_more_params.max_page)
                        button.css({ display: "none" });
                    else {
                        button.text('Show More')
                    }
                } else {
                    button.css({ display: "none" });
                }
            },
        })
    })
})
